var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtivarCartao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.01 25.8501H5.22998C4.43433 25.8501 3.67127 25.534 3.10866 24.9714C2.54605 24.4088 2.22998 23.6457 2.22998 22.8501V4.8501C2.22998 4.05445 2.54605 3.29139 3.10866 2.72878C3.67127 2.16617 4.43433 1.8501 5.22998 1.8501H32.23C33.0256 1.8501 33.7887 2.16617 34.3513 2.72878C34.9139 3.29139 35.23 4.05445 35.23 4.8501V15.7301",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22998 10.8501H35.23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 20.3341L32.6849 26.6491L29.8149 23.7791",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivarCartao);
export default __webpack_public_path__ + "static/media/ativarCartao.50cecf9dafc202303f42a58a9813c29f.svg";
export { ForwardRef as ReactComponent };